import { FC } from "react"
import {
  ChoiceCard as MarmaladeChoiceCard,
  ChoiceCardProps
} from "@eventbrite/marmalade"
import classNames from "classnames"

// styles
import { choiceCardButton } from "./ChoiceCard.module.scss"

export interface Props extends ChoiceCardProps {
  wrapperButtonClassName?: string
  wrapperButtonOnClick?: React.MouseEventHandler<HTMLButtonElement>
  wrapperButtonOnKeyUp?: React.KeyboardEventHandler<HTMLButtonElement>
}

export const ChoiceCard: FC<Props> = ({
  children,
  wrapperButtonClassName,
  wrapperButtonOnClick,
  wrapperButtonOnKeyUp,
  ...otherArgs
}) => {
  return (
    <button
      className={classNames(choiceCardButton, wrapperButtonClassName)}
      tabIndex={0}
      onClick={wrapperButtonOnClick}
      onKeyUp={wrapperButtonOnKeyUp}
    >
      <MarmaladeChoiceCard {...otherArgs}>{children}</MarmaladeChoiceCard>
    </button>
  )
}
